import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmYourInformationModal } from '../../src/modal/ConfirmYourInformationModal';
import { InfoChartModal } from '../../src/modal/InfoChartModal';
import { useNavigate } from 'react-router-dom';
import UniformImage from "../components/font-end/UniformSurvey/UniformImage";
import {
  SaveSurvey,
  GetUniformType,
  GetJoblevels,
} from '../../src/services/ApiUniformSurvey';
import {
  UniformBenefitById,
  UniformLastest,
  GetUniformBenefitIncorrect,
} from '../../src/services/ApiUniformSurveyBackoffice';
import {
  UniformBenefitType,
  ProfileSurveyType,
  UniformLatestType,
} from '../../src/model/datatype';
import { ConfirmHandleErrorModal } from '../../src/modal/ConfirmHandleErrorModal';
import { useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import parse from 'html-react-parser';
import { UniformType, JobLevelsType } from '../model/datatype';
import { Value } from 'sass';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

export const CreateUniformSueryForUsers = (props: any) => {
  const [notFoundType, setNotFoundType] = useState(false);
  const [uniformList, setUniformList] = useState([]);
  const [jobLevels, setJobLevels] = useState([]);
  const [itemTumbler, setTumbler] = useState('');
  const [data, setData] = useState<ProfileSurveyType | null>(null);
  const [showErrorBody, setShowErrorBodyModal] = useState('');
  const [showError, setShowErrorModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chartModal, setChartModal] = useState(false);
  const [show, setShow] = useState('none');
  const [showModalConfrim, setShowModalComfrim] = useState(false);
  const [uniformTypeImages, setUniformTypeImages] = useState(
    '../images/UniformSurvey.png',
  );
  const [uniformtype, setUniformtype] = useState<UniformBenefitType | null>(
    null,
  );
  const [email, setEmail] = useState('');
  const [uniformAmont, setUniformAmont] = useState(0);
  const [uniformImage, setUniformImage] = useState('');
  const [shirtGender, setShirtGender] = useState('');
  const [pantGender, setPantGender] = useState('');
  const [itemType, setItemType] = useState('');
  const [validdateData, setValidateData] = useState('');
  const [modalValidateShow, setModalValidateShow] = useState(false);
  const [uniformLastest, setUniformLastest] =
    useState<UniformLatestType | null>(null);
  const [uniformTypeText, setUniformTypeText] = useState('');
  const [pageLoder, setPageLoder] = useState(false);
  const [slectUniformType, setSlectUniformType] = useState({
    uniFormType: '',
    jobLevel: '',
  });
  const [slectUniformVal, setSlectUniformVal] = useState('');
  const [slectJobLevel, setSelectJobLevel] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [modalClose, SetModalClose] = useState(props.showModal);
  const [statusCheck, setStatusCheck] = useState(true);
  const [validdateDataUnifrom, setValidateDataUnfirom] = useState('');
  const [jsGetJob, setJsGetJob] = useState('');
  const [employeeNameTh, setEmployeeNameTh] = useState('');

  let { t } = useTranslation();
  let navigate = useNavigate();
  let location: any = useLocation();

  const [employeeID, setEmployeeID] = useState();
  const [employeeIDSave, setEmployeeIDSave] = useState();
  const [JobLevel, setJobLevel] = useState();
  const [searchType, setSearchType] = useState<'employeeId' | 'employeeId7Digit'>('employeeId');
  const sizeMale = [
    { key: 26, value: 26 },
    { key: 28, value: 28 },
    { key: 30, value: 30 },
    { key: 32, value: 32 },
    { key: 34, value: 34 },
    { key: 36, value: 36 },
    { key: 38, value: 38 },
    { key: 40, value: 40 },
    { key: 44, value: 44 },
    { key: 46, value: 46 },
  ];

  const sizefeMale = [
    { key: 26, value: 26 },
    { key: 28, value: 28 },
    { key: 30, value: 30 },
    { key: 32, value: 32 },
    { key: 34, value: 34 },
    { key: 36, value: 36 },
    { key: 38, value: 38 },
    { key: 40, value: 40 },
  ];
  const sizeShirtAll = [
    { key: 'SS', value: 'SS' },
    { key: 'S', value: 'S' },
    { key: 'M', value: 'M' },
    { key: 'L', value: 'L' },
    { key: 'XL', value: 'XL' },
    { key: 'XXL', value: 'XXL' },
    { key: '3XL', value: '3XL' },
  ];

  const dressSizeList = [
    { key: 5, value: 5 },
    { key: 7, value: 7 },
    { key: 9, value: 9 },
    { key: 11, value: 11 },
    { key: 13, value: 13 },
    { key: 15, value: 15 },
    { key: 17, value: 17 },
    { key: 19, value: 19 },
    { key: 21, value: 21 },
    { key: 23, value: 23 },
  ];

  let flagCheck = true;
  const [surveys, setSurveys] = useState({
    jobLevel: JobLevel,
    employeeId: '',
    EmpID7Digits: '',
    shirtType: '',
    shirtGender: '',
    pantGender: '',
    shirtQty: null,
    shirtSize: '',
    pantQty: null,
    pantSize: '',
    dressQty: null,
    dressSize: '',
    slipperQty: null,
    slipperSize: '',
    braQty: null,
    braSize: '',
    tumblerQty: null,
    tumblerType: '',
  });
  const checkArray = (value: any) => {
    const disableType = [
      'Maintenance',
      'Driver Shirt',
      'TL Shirt',
      'Staff Shirt',
      'GL Shirt',
    ];
    return disableType.indexOf(value) > -1;
  };
  //console.log('props.employeeID=', props.employeeID);
  useEffect(() => {
    //submitSearchEmployee()
    setEmployeeID(props.employeeID);

    //if (uniformList.length <= 0) {
    GetUniformType()
      .then((response) => {
        const getData: any = response;
        setUniformList(getData);
      })
      .catch((error: any) => {
        //console.log('error=', error);
      });
    // }
    // if (jobLevels.length <= 0) {
    GetJoblevels()
      .then((response) => {
        const getData: any = response;
        setJobLevels(getData);
      })
      .catch((error: any) => {
        // console.log('error=', error);
      });
    //  }
  }, [employeeID, isInvalid, isValid, uniformtype]);
  //console.log('uniformtype=', uniformtype);

  useEffect(() => {
    !props?.isCreateForm && props?.employeeID && submitSearchEmployee();
    //(props?.isCreateForm)?props?.employeeID === "":"";
  }, [props?.employeeID]);

  const handleErrorOpen = () => {
    setShowErrorModal(true);
  };

  const handleErrorClose = () => {
    setShowErrorModal(false);
  };
  const ValidateForm = () => {
    //console.log('ValidateFormsurvey=>', surveys);
    let shirtValidate: string = '';
    let pantValidate: string = '';
    let dressValidate: string = '';
    let slipperValidate: string = '';
    let brasValidate: string = '';
    let tumlerTypeValidate: string = '';
    let ValidateMsg: string = '';
    let shirtGenderMessage: string = '';
    let pantsGenderMessage: string = '';
    //console.log("Valid==>", surveys)
    if (
      (surveys.shirtQty !== null && shirtGender === undefined) ||
      (surveys.shirtQty !== null && shirtGender === null) ||
      (surveys.shirtQty !== null && shirtGender === '')
    ) {
      shirtGenderMessage =
        '<li>' +
        t('uniform_survey.request_message.request_gender_shirts') +
        '</li>';
    }

    if (surveys.shirtQty !== null && surveys.shirtSize === '') {
      shirtValidate =
        '<li>' +
        t('uniform_survey.request_message.request_shirts_message') +
        '</li>';
    }

    if (
      (surveys.pantQty !== null && pantGender === undefined) ||
      (surveys.pantQty !== null && pantGender === null) ||
      (surveys.pantQty !== null && pantGender === '')
    ) {
      pantsGenderMessage =
        '<li>' +
        t('uniform_survey.request_message.request_gender_pants') +
        '</li>';
    }

    if (surveys.pantQty !== null && surveys.pantSize === '') {
      pantValidate =
        '<li>' +
        t('uniform_survey.request_message.request_pants_message') +
        '</li>';
    }

    if (surveys.dressQty !== null && surveys.dressSize === '') {
      dressValidate =
        '<li>' +
        t('uniform_survey.request_message.request_dresses_message') +
        '</li>';
    }
    if (surveys.slipperQty !== null && surveys.slipperSize === '') {
      slipperValidate =
        '<li>' +
        t('uniform_survey.request_message.request_slippers_message') +
        '</li>';
    }
    if (surveys.braQty !== null && surveys.braSize === '') {
      brasValidate =
        '<li>' +
        t('uniform_survey.request_message.request_bras_message') +
        '</li>';
    }
    if (surveys.tumblerQty !== null && surveys.tumblerType === '') {
      tumlerTypeValidate =
        '<li>' +
        t('uniform_survey.request_message.request_tumbler_message') +
        '</li>';
    }
    ValidateMsg =
      shirtGenderMessage +
      shirtValidate +
      pantsGenderMessage +
      pantValidate +
      dressValidate +
      slipperValidate +
      brasValidate +
      tumlerTypeValidate;
    return ValidateMsg;
  };

  function ValidateFormUnifrom() {
    let ValidateMsg: string = '';
    let jobLevelValidate: string = '';
    let selectTypeValidate: string = '';
    let text: any = '';
    let select: any = document.getElementById('jobLevel');
    //alert(select);
    if (select !== null) {
      text = select.options[select.selectedIndex].text;
      setJsGetJob(text);
    }

    if (!checkArray(slectUniformVal) && slectUniformType.uniFormType === '') {
      jobLevelValidate = 'empty Level uniFormType';
    } else {
      jobLevelValidate = '';
    }

    if (!checkArray(slectUniformVal) && text === '--- Job Level ---') {
      jobLevelValidate = 'empty Level uniFormType';
    } else {
      jobLevelValidate = '';
    }

    if (slectUniformVal === '') {
      selectTypeValidate = 'empty selectType';
    } else {
      selectTypeValidate = '';
    }

    ValidateMsg = jobLevelValidate + selectTypeValidate;
    return ValidateMsg;
  }
  const handleOpen = () => {
    const validFrom: string = ValidateForm();
    const validType: string = ValidateFormUnifrom();

    setValidateDataUnfirom(validType);
    setValidateData(validFrom);

    if (validFrom === '') {
      setShowModal(true);
    } else {
      setModalValidateShow(true);
    }

    //console.log('Submit Survey==>', surveys);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleChartOpen = (item: string) => {
    setItemType(item);
    setChartModal(true);
  };

  const handleChartClose = () => {
    setChartModal(false);
  };

  const handleStartSurvey = () => {
    setShowModalComfrim(true);
  };

  const handleErrorYes = () => {
    setShowModal(true);
    setShowErrorModal(false);
  };

  const handleErrorNo = () => {
    setShowModal(true);
    setShowErrorModal(false);
  };

  const closeModalClearData = () => {
    // alert("Close");
    setUniformtype(null);
    props?.setEmployeeID('');
    props.handleContinue();
    setIsValid(false);
    setIsInvalid(false);
  };

  const showModalData = () => {};

  const handleYes = () => {
    const finalSurveys = {
      ...surveys,
      shirtType: slectUniformVal || uniformtype?.shirtType || '', // fallback chain
      EmpID7Digits: searchType === 'employeeId7Digit' ? (props?.employeeID || '') : '',
    };

    SaveSurvey(finalSurveys)
      .then((response) => {
        const getData: any = response;
        setShowModal(false);
        setUniformtype(null);
        props?.setEmployeeID('');
        props.handleContinue();
        props.clearData();
        Swal.fire('Summary Save', 'Successfuly', 'info');
        Swal.update({
          icon: 'success',
        });
      })
      .catch((error: any) => {
        setShowErrorBodyModal(error);
        setShowErrorModal(true);
        setShowModal(false);
      });
  };

  const setInputSizeValue = (e: any) => {
    const { name, value } = e.target;
    // console.log('name=',name);
    // console.log('value=',value);

    if (name === 'shirtSize') {
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else if (name === 'pantSize') {
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else if (name === 'gender-shirt') {
      setShirtGender(value);
      setSurveys((oldValues: any) => ({
        ...oldValues,
        ['shirtSize']: surveys?.shirtSize,
      }));
      setSurveys((oldValues: any) => ({
        ...oldValues,
        ['shirtGender']: value,
      }));
    } else if (name === 'gender-pants') {
      setPantGender(value);
      setSurveys((oldValues: any) => ({
        ...oldValues,
        ['pantSize']: surveys?.pantSize,
      }));
      setSurveys((oldValues: any) => ({ ...oldValues, ['pantGender']: value }));
    } else if (name === 'tumblerType') {
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else {
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    }
  };
  function ValidateFormModal(props: any) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal-confirm uniformModel validaform"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t('uniform_survey.request_message.request_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <ul>{parse(props.message)}</ul>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-yes  " onClick={props.onHide}>
            {t('uniform_survey.error_message.btn_no')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // alert(uniformImage);
  const setInputChangeType = (e: any) => {
    const { name, value } = e.target;
    setSlectUniformVal(value);

    if (value == '') {
      setUniformTypeText(uniformTypeText);
      setUniformTypeImages(uniformTypeImages);
     // console.log('xxx=', uniformImage);
      setUniformImage(uniformImage);
    } else {
      setUniformTypeText(e.target.selectedOptions[0].label);
      setUniformTypeImages(value);
      setUniformImage(value);
      setSurveys((oldValues: any) => ({ ...oldValues, ['shirtType']: value }));

      //setUniformtype(null);
      GetUniformBenefitIncorrect({
        uniFormType: value,
        jobLevel: slectJobLevel,
        email: email,
      })
        .then((response) => {
          // if (!response) {
          //   setNotFoundType(true);
          // }
          //console.log('GetUniformBenefitIncorrect=', response);
          setUniformtype(response);

          setUniformTypeImages(response.shirtType);
          if (localStorage.getItem('Language') === 'en') {
            setUniformTypeText(response.shirtDescriptionEn);
          } else {
            setUniformTypeText(response.shirtDescriptionTh);
          }

          setSurveys((oldValues: any) => ({
            ...oldValues,
            jobLevel: response?.jobLevel,
            shirtType: response.shirtType,
            shirtQty: response.shirtQty,
            pantQty: response.pantsQty,
            slipperQty: response.slipperQty,
            tumblerQty: response.tumblerQty,
            dressQty: response.dressQty,
            braQty: response.braQty,
          }));
          const getData: any = response;
        })
        .catch((error: any) => {
          setNotFoundType(true);
          closeModalClearData();
          return Swal.fire({
            icon: 'error',
            title: 'Something went wrong!',
            text: 'Data not Found.',
          });
          //console.log('error=', error);
          //counter++;
        });
    }
  };

  const setInputChangeJobLevel = (e: any) => {
    const { name, value } = e.target;
    setSelectJobLevel(value);
    setSlectUniformType((oldValues: any) => ({
      ...oldValues,
      [name]: value,
      jobLevel: value,
    }));
    GetUniformBenefitIncorrect({
      uniFormType: slectUniformVal,
      jobLevel: value,
      email: email,
    })
      .then((response) => {
        setUniformtype(response);
        setUniformTypeImages(response.shirtType);
        if (localStorage.getItem('Language') === 'en') {
          setUniformTypeText(response.shirtDescriptionEn);
        } else {
          setUniformTypeText(response.shirtDescriptionTh);
        }

        setSurveys((oldValues: any) => ({
          ...oldValues,
          jobLevel: response?.jobLevel,
          shirtType: response.shirtType,
          shirtQty: response.shirtQty,
          pantQty: response.pantsQty,
          slipperQty: response.slipperQty,
          tumblerQty: response.tumblerQty,
          dressQty: response.dressQty,
          braQty: response.braQty,
        }));
        const getData: any = response;
      })
      .catch((error: any) => {
        closeModalClearData();
        return Swal.fire({
          icon: 'error',
          title: 'Something went wrong!',
          text: 'Data not Found.',
        });
        // console.log('error=', error);
        //counter++;
      });
  };

  const submitSearchEmployee = () => {
    // const { name, value } = e.target;

    // console.log('uniformLastestStat=>',uniformLastest);
    //setUniformLastest(null)
    const requiredDigits = searchType === 'employeeId7Digit' ? 7 : 5;
    if (!props?.employeeID || props?.employeeID === '') {
      setIsInvalid(true);
      setIsValid(false);
      return false;
    } else if (/^\d+$/.test(props?.employeeID) && props?.employeeID.length !== requiredDigits) {
      setIsInvalid(true);
      setIsValid(false);
      return false;
    } else {
      setIsValid(true);
      setIsInvalid(false);
    }

    //setPageLoder(true);
    setSurveys((oldValues: any) => ({
      ...oldValues,
      ['employeeId']: props?.employeeID,
    }));
    //setUniformLastest(null)

    UniformLastest(props?.employeeID, searchType)
      .then((res) => {
        if (res !== '') {
          // ถ้าไม่มี shirtType → ให้เรียก UniformBenefitById แทน (ข้อมูลไม่สมบูรณ์)
          if (!res.shirtType) {
            
            UniformBenefitById(props?.employeeID)
              .then((response) => {
                setPageLoder(false);
                
                setEmail(response.employeeInfo.email);
                setEmployeeNameTh(response.employeeInfo.employeeNameTh);
                setUniformtype(response);
                setSlectUniformVal(response.shirtType);
                setSelectJobLevel(response.jobLevel);
                setUniformTypeText(response.shirtType);
                setUniformImage(response.shirtType);
                setUniformTypeImages(response.shirtType);
                
                // Set gender from previous survey if available
                if (res.shirtGender) setShirtGender(res.shirtGender);
                if (res.pantGender) setPantGender(res.pantGender);
                
                setSurveys((oldValues: any) => ({
                  ...oldValues,
                  employeeId: response.employeeInfo.employeeId,
                  EmpID7Digits: searchType === 'employeeId7Digit' ? props?.employeeID : '',
                  jobLevel: response?.jobLevel,
                  shirtType: response.shirtType,
                  shirtQty: response.shirtQty,
                  pantQty: response.pantsQty,
                  slipperQty: response.slipperQty,
                  tumblerQty: response.tumblerQty,
                  dressQty: response.dressQty,
                  braQty: response.braQty,
                  // Keep existing size/gender from res if available
                  shirtSize: res.shirtSize || '',
                  shirtGender: res.shirtGender || '',
                  pantSize: res.pantSize || '',
                  pantGender: res.pantGender || '',
                  dressSize: res.dressSize || '',
                  slipperSize: res.slipperSize || '',
                  braSize: res.braSize || '',
                  tumblerType: res.tumblerType || '',
                }));
              })
              .catch((error: any) => {
                setPageLoder(false);
                return Swal.fire({
                  icon: 'warning',
                  title: 'Data not Found.',
                  text: 'Please check the keyword or employee ID input.',
                });
              });
            return; // Exit early
          }
          
          // กรณีมี shirtType จาก UniformLastest
          setJobLevel(res.jobLevel);
          setEmail(res.employeeId);
          setEmployeeNameTh(res.employeeName);
          setPageLoder(false);
          setUniformLastest(res);
          setUniformtype(res);
          setShirtGender(res.shirtGender);
          setPantGender(res.pantGender);
          setSelectJobLevel(res.jobLevel);
          setSlectUniformVal(res.shirtType);
          setUniformTypeText(res.shirtType);
          setUniformImage(res.shirtType);

          // Fetch description fields จาก GetUniformBenefitIncorrect
          GetUniformBenefitIncorrect({
            uniFormType: res.shirtType,
            jobLevel: res.jobLevel,
            email: res.employeeId,
          })
            .then((benefitRes: any) => {
              if (benefitRes) {
                setUniformtype((prev: any) => ({
                  ...prev,
                  shirtDescriptionTh: benefitRes.shirtDescriptionTh,
                  shirtDescriptionEn: benefitRes.shirtDescriptionEn,
                  pantsDescriptionTh: benefitRes.pantsDescriptionTh,
                  pantsDescriptionEn: benefitRes.pantsDescriptionEn,
                  dressDescriptionTh: benefitRes.dressDescriptionTh,
                  dressDescriptionEn: benefitRes.dressDescriptionEn,
                  slipperDescriptionTh: benefitRes.slipperDescriptionTh,
                  slipperDescriptionEn: benefitRes.slipperDescriptionEn,
                  braDescriptionTh: benefitRes.braDescriptionTh,
                  braDescriptionEn: benefitRes.braDescriptionEn,
                  tumblerDescriptionTh: benefitRes.tumblerDescriptionTh,
                  tumblerDescriptionEn: benefitRes.tumblerDescriptionEn,
                }));
                if (localStorage.getItem('Language') === 'en') {
                  setUniformTypeText(benefitRes.shirtDescriptionEn);
                } else {
                  setUniformTypeText(benefitRes.shirtDescriptionTh);
                }
              }
            })
            .catch(() => {});

          setSurveys((oldValues: any) => ({
            ...oldValues,
            employeeId: res.employeeId,
            EmpID7Digits: searchType === 'employeeId7Digit' ? props?.employeeID : '',
            jobLevel: res?.jobLevel,
            shirtType: res.shirtType || '', // จะถูก override ภายหลังถ้า GetUniformBenefitIncorrect มีค่า
            shirtQty: res.shirtQty,
            pantQty: res.pantQty,
            slipperQty: res.slipperQty,
            tumblerQty: res.tumblerQty,
            dressQty: res.dressQty,
            braQty: res.braQty,
            shirtSize: res.shirtSize,
            shirtGender: res.shirtGender,
            pantSize: res.pantSize,
            pantGender: res.pantGender,
            dressSize: res.dressSize,
            slipperSize: res.slipperSize,
            braSize: res.braSize,
            tumblerType: res.tumblerType,
          }));
        } else {
          UniformBenefitById(props?.employeeID)
            .then((response) => {
              setPageLoder(false);
              setEmail(response.employeeInfo.email);
              setEmployeeNameTh(response.employeeInfo.employeeNameTh);
              setEmployeeIDSave(response.employeeInfo.employeeId);
              setUniformtype(response);
              setSlectUniformVal(response.shirtType);
              setSlectUniformType(response.shirtType);
              setSelectJobLevel(response.jobLevel);
              setUniformTypeText(response.shirtType);
              setUniformImage(response.shirtType);
              setUniformTypeImages(response.shirtType);

              const total =
                response.shirtQty +
                response.pantsQty +
                response.slipperQty +
                response.tumblerQty +
                response.dressQty +
                response.braQty;
              setUniformAmont(total);

              setSurveys((oldValues: any) => ({
                ...oldValues,
                employeeId: response.employeeInfo.employeeId,
                jobLevel: response?.jobLevel,
                shirtType: response.shirtType,
                shirtQty: response.shirtQty,
                pantQty: response.pantsQty,
                slipperQty: response.slipperQty,
                tumblerQty: response.tumblerQty,
                dressQty: response.dressQty,
                braQty: response.braQty,
              }));
            })
            .catch((error: any) => {
              setPageLoder(false);
              return Swal.fire({
                icon: 'warning',
                title: 'Data not Found.',
                text: 'Please check the keyword or Employee ID input.',
              });
              // toast.error('Data not found please try again', {
              //   position: 'top-right',
              //   autoClose: 4000,
              //   hideProgressBar: false,
              //   closeOnClick: true,
              //   pauseOnHover: true,
              //   draggable: true,
              //   progress: undefined,
              // });
              // setUniformtype(null);
              // props?.setEmployeeID('');
              // props.handleContinue();
              // props.clearData();
              //counter++;
            });
          //console.log('surveyGetUniformBenefitIncorrect', surveys);
        }
      })
      .catch((error: any) => {
        setPageLoder(false);
        alert(error);

        //console.log('error=', error);
      });
  };

  const inputEmployeeID = (e: any) => {
    const { name, value } = e.target;
    //alert(props.employeeID);
    // if(props.employeeID === 0){
    //     setEmployeeID("");
    // }
    const requiredDigits = searchType === 'employeeId7Digit' ? 7 : 5;
    if (value === '') {
      setIsInvalid(true);
      setIsValid(false);
    } else if (/^\d+$/.test(value) && value.length !== requiredDigits) {
      setIsInvalid(true);
      setIsValid(false);
    } else {
      setIsValid(true);
      setIsInvalid(false);
    }

    //('inputValue=', value);
    props?.setEmployeeID(value);
  };

  //console.log('uniformtype', uniformtype);
  //console.log('email=', email);
  return (
    <>
      <ConfirmHandleErrorModal
        showModal={showError}
        handleContinue={handleErrorClose}
        click_no={handleErrorNo}
        errorMessage={showErrorBody}
        click_yes={handleErrorYes}
      />
      <InfoChartModal
        showModal={chartModal}
        handleContinue={handleChartClose}
        cancel={handleChartClose}
        click_yes=""
        shirtGender={shirtGender}
        pantGender={pantGender}
        itemtype={itemType}
      />
      <ConfirmYourInformationModal
        showModal={showModal}
        handleContinue={handleClose}
        cancel={handleClose}
        click_yes={handleYes}
        benefit={uniformtype}
        surveys={surveys}
        shirtGender={shirtGender}
        pantGender={pantGender}
        uniformImage={uniformImage}
      />

      <Modal
        centered
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        show={props.showModal}
        onHide={closeModalClearData}
        backdrop="static"
        keyboard={true}
        className="Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="uniform-title">
            Uniform Survey for Users
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="uniform-survey-info mt-0 pt-0">
            <Container>
              <Row>
                {/* <Col  md={2}>
                                {(uniformTypeImages !== "")?
                                <><img src={uniformTypeImages} alt="UniformSurvey" className="m-2 mb-2 rounded border w-100 item-shadow" /></> 
                                :
                                <><img src={uniformImage} alt="UniformSurvey" className="m-2 mb-2 rounded border w-100 item-shadow" /></>
                             }
                               
                            </Col> */}
                {/* <Col md={5} className="text-start">
                                <div className="title-tpye m-1 mt-3 mb-2 " style={{fontSize:"14px"}}>{t('uniform_survey.your_uniform.uniform_type')}</div>
                                <div className="title-show-type m-1 mb-3 h-3">{(uniformTypeText === "")?props.uniformType:uniformTypeText}</div>
                            </Col> */}
                <Col md={3} className="pt-2 fw-bolder">
                  Search By:
                </Col>
                <Col md={9} className="p-0 pt-2">
                  <div className="d-flex gap-4 ps-2 mb-2">
                    <Form.Check
                      type="radio"
                      label="Emp ID (5 Digits)"
                      name="searchType"
                      id="searchTypeEmpId"
                      value="employeeId"
                      checked={searchType === 'employeeId'}
                      onChange={() => {
                        setSearchType('employeeId');
                        setUniformtype(null);
                        setUniformLastest(null);
                        setEmployeeNameTh('');
                        props?.setEmployeeID('');
                        setIsValid(false);
                        setIsInvalid(false);
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="Emp ID (7 Digits)"
                      name="searchType"
                      id="searchTypeEmpId7"
                      value="employeeId7Digit"
                      checked={searchType === 'employeeId7Digit'}
                      onChange={() => {
                        setSearchType('employeeId7Digit');
                        setUniformtype(null);
                        setUniformLastest(null);
                        setEmployeeNameTh('');
                        props?.setEmployeeID('');
                        setIsValid(false);
                        setIsInvalid(false);
                      }}
                    />
                  </div>
                </Col>
                <Col md={3} className="pt-1 fw-bolder">
                </Col>
                <Col md={6} className="p-0">
                  {/* <div className="title-tpye m-1 mt-3 mb-2">EmployeeID:</div> */}
                  <div className="title-show-typ3 ps-2  ">
                    <Form.Control
                      type="text"
                      inputMode="numeric"
                      placeholder={searchType === 'employeeId' ? 'Emp ID (5 Digits)' : 'Emp ID (7 Digits)'}
                      name="employeeID"
                      onChange={(e: any) => {
                        e.target.value = e.target.value.replace(/\D/g, '');
                        inputEmployeeID(e);
                      }}
                      isValid={isValid}
                      isInvalid={isInvalid}
                      autoComplete="off"
                      value={props?.employeeID || ''}
                    />
                    {/* <Form.Control type="number" placeholder="Employee ID" name="employeeID"     isValid={isValid}  isInvalid={isInvalid} /> */}
                  </div>
                </Col>

                <Col md={3} className="text-start p-0">
                  <Button
                    className="btn-submit ms-3"
                    id="create_an"
                    onClick={(e: any) => submitSearchEmployee()}
                  >
                    {' '}
                    Search
                  </Button>
                </Col>
              </Row>
              {uniformtype && uniformtype?.shirtQty != null ? (
                <>
                  <Row>
                    <Col md={3} className="pt-2 fw-bolder mt-2">
                      Employee Name:
                    </Col>
                    <Col md={9} className="p-0">
                      <div className="title-show-typ3 ps-2  pt-2 mt-2">
                        {employeeNameTh}
                      </div>
                    </Col>
                  </Row>

                  <Row className="uniform-type-item">
                    <Col md="3" className="pt-3 fw-bolder">
                      Uniform Type :
                    </Col>
                    <Col md="6" className="p-0 pe-2">
                      {/* <div className="title-tpye m-1 mt-3 mb-2 h-3" style={{fontSize:"15px"}}>Current Unifrom Type</div> */}
                      <Form.Select
                        value={slectUniformVal}
                        className={`m-2 mb-3`}
                        name="uniFormType"
                        onChange={(e: any) => setInputChangeType(e)}
                      >
                        {/* <option value="">--- Uniform Type ---</option> */}
                        {uniformList !== null ? (
                          <>
                            {uniformList.map(
                              (item: UniformType, index: number) => (
                                <option value={item.name} key={index}>
                                  {item.name}
                                </option>
                              ),
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Form.Select>
                    </Col>
                    <Col md="3" className="p-0 "></Col>
                  </Row>
                  {!checkArray(slectUniformVal) ? (
                    <Row className="uniform-job-level-item">
                      <Col md="3" className="pt-3 fw-bolder">
                        Job Level :
                      </Col>
                      <Col md="6" className="p-0 pe-2">
                        <Form.Select
                          value={slectJobLevel}
                          className={`m-2 ${validdateDataUnifrom !== ''}`}
                          name="jobLevel"
                          id="jobLevel"
                          onChange={(e: any) => setInputChangeJobLevel(e)}
                        >
                          {/* <option value="">--- Job Level ---</option> */}
                          {jobLevels !== null ? (
                            <>
                              {jobLevels.map(
                                (item: JobLevelsType, index: number) => (
                                  <option
                                    value={item.name}
                                    key={`jb-${item.id}`}
                                  >
                                    {item.name}
                                  </option>
                                ),
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                      </Col>
                      <Col md="3" className="p-0"></Col>
                    </Row>
                  ) : (
                    <></>
                  )}

                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={2} md={1} lg={1} className="p-0 m-0">
                      <div className="bg-cicle-title">
                        <img
                          src="../images/UniformSurvey.png"
                          alt="UniformSurvey"
                          width={40}
                          className="mt-1"
                        />
                      </div>
                    </Col>
                    <Col xs={4} md={4} lg={7} className="p-0">
                      <div
                        className="px-2"
                        style={{ fontSize: '18px', lineHeight: '50px' }}
                      >
                        Select Uniform Size
                      </div>
                    </Col>
                    {/* <Col xs={6} md={6} lg={4} className="text-end mt-1 px-0">
                                <Button className="btn-check-survey" onClick={() => handleOpen()}>{t('uniform_survey.choose_uniform.btn_sumbit_uniform')}</Button>
                            </Col> */}
                  </Row>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-danger">
                        {t(
                          'uniform_survey.choose_uniform.messages_alert_big_size',
                        )}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.shirtQty != null ? (
                <Row>
                  <Col
                    xs={4}
                    md={2}
                    lg={2}
                    className="uniform-item m-0 p-0"
                    onClick={() => handleChartOpen('shirt')}
                  >
                    <UniformImage
                      imagesName={uniformImage}
                      size="sm"
                      customSize={100}
                    />
                    {/* <img
                      src={uniformImage}
                      alt="UniformSurvey"
                      className=" m-2 mb-2 item-shadow rounded border"
                      width={100}
                    /> */}
                    <div className="size-chart">
                      <img
                        src="../images/pie-chart.png"
                        alt="chart-icon"
                        className="img-uniform"
                      />
                      <label className="size-chart-title">
                        {t('uniform_survey.choose_uniform.size_chart')}
                      </label>
                    </div>
                  </Col>
                  <Col xs={7} md={8} lg={8} className="pt-2">
                    <div className="choose-show font-wiegth-bold mb-2">
                      {slectUniformVal}
                    </div>
                    <div>
                      <Form.Check
                        className="choose-gender-check"
                        inline
                        checked={shirtGender === 'Male' ? true : false}
                        label={t('uniform_survey.choose_uniform.male')}
                        name="gender-shirt"
                        type="radio"
                        value="Male"
                        id={`inline-radio-1`}
                        onChange={(e: any) => setInputSizeValue(e)}
                      />
                      <Form.Check
                        className="choose-gender-check"
                        inline
                        label={t('uniform_survey.choose_uniform.female')}
                        checked={shirtGender === 'Female' ? true : false}
                        name="gender-shirt"
                        type="radio"
                        value="Female"
                        id={`inline-radio-2`}
                        onChange={(e: any) => setInputSizeValue(e)}
                      />
                    </div>
                    <div>
                      <Form.Select
                        as="select"
                        value={surveys.shirtSize}
                        className={`mt-2 mb-3 ${
                          validdateData !== '' &&
                          surveys.shirtSize === undefined
                            ? 'require'
                            : ''
                        }`}
                        size="sm"
                        name="shirtSize"
                        onChange={(e: any) => setInputSizeValue(e)}
                      >
                        <option value="">
                          {t('uniform_survey.choose_uniform.select_size')}
                        </option>
                        {sizeShirtAll.map((item: any, index: number) => (
                          <option value={item.key} key={index}>
                            {item.value}
                          </option>
                        ))}
                        <option value="Bigger than normal size">
                          {t('uniform_survey.choose_uniform.big_size')}
                        </option>
                        <option value="Decline">
                          {t('uniform_survey.choose_uniform.no_receive')}
                        </option>
                      </Form.Select>
                    </div>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="p-2">
                    <div className="text-center font-wiegth-bold">
                      {uniformtype?.shirtQty}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              {(uniformtype && uniformtype?.pantsQty != null) ||
              (uniformtype && uniformtype?.pantQty != null) ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() => handleChartOpen('pants')}
                    >
                      <img
                        src="../images/uniform/pants.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t('uniform_survey.choose_uniform.size_chart')}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      {localStorage.getItem('Language') === 'en' ? (
                        <>
                          {uniformtype.shirtType === 'Maintenance' ||
                          uniformtype.shirtType === 'Driver Shirt'
                            ? uniformtype?.pantsDescriptionEn
                            : uniformtype?.pantsDescriptionEn}
                        </>
                      ) : (
                        <>
                          {uniformtype.shirtType === 'Maintenance' ||
                          uniformtype.shirtType === 'Driver Shirt'
                            ? uniformtype?.pantsDescriptionTh
                            : uniformtype?.pantsDescriptionTh}
                        </>
                      )}
                      <div>
                        <Form.Check
                          className="choose-gender-check"
                          inline
                          checked={pantGender === 'Male' ? true : false}
                          label={t('uniform_survey.choose_uniform.male')}
                          name="gender-pants"
                          type="radio"
                          value="Male"
                          id={`inline-radio-3`}
                          onChange={(e: any) => setInputSizeValue(e)}
                        />
                        <Form.Check
                          className="choose-gender-check"
                          inline
                          checked={pantGender === 'Female' ? true : false}
                          label={t('uniform_survey.choose_uniform.female')}
                          name="gender-pants"
                          type="radio"
                          value="Female"
                          id={`inline-radio-4`}
                          onChange={(e: any) => setInputSizeValue(e)}
                        />
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.pantSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== '' &&
                            surveys.pantSize === undefined
                              ? 'require'
                              : ''
                          }`}
                          size="sm"
                          name="pantSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t('uniform_survey.choose_uniform.select_size')}
                          </option>
                          {pantGender === 'Male'
                            ? sizeMale.map((item: any, index: number) => (
                                <option value={item.key} key={index}>
                                  {item.value}"
                                </option>
                              ))
                            : sizefeMale.map((item: any, index: number) => (
                                <option value={item.key} key={index}>
                                  {item.value}"
                                </option>
                              ))}
                          <option value="Bigger than normal size">
                            {t('uniform_survey.choose_uniform.big_size')}
                          </option>
                          <option value="Decline">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {uniformtype?.pantsQty}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.dressQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() => handleChartOpen('dress')}
                    >
                      <img
                        src="../images/uniform/dress.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t('uniform_survey.choose_uniform.size_chart')}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem('Language') === 'en'
                          ? uniformtype?.dressDescriptionEn
                          : uniformtype?.dressDescriptionTh}
                      </div>

                      <div>
                        <Form.Select
                          value={surveys.dressSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== '' &&
                            surveys.dressSize === undefined
                              ? 'require'
                              : ''
                          }`}
                          size="sm"
                          name="dressSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t('uniform_survey.choose_uniform.select_size')}
                          </option>
                          {dressSizeList.map((item: any, index: number) => (
                            <option value={item.key} key={index}>
                              {item.value}''
                            </option>
                          ))}
                          <option value="Bigger than normal size">
                            {t('uniform_survey.choose_uniform.big_size')}
                          </option>
                          <option value="Decline">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {uniformtype?.dressQty}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.slipperQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() => handleChartOpen('slippers')}
                    >
                      <img
                        src="../images/uniform/slippers.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t('uniform_survey.choose_uniform.size_chart')}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem('Language') === 'en'
                          ? uniformtype?.slipperDescriptionEn
                          : uniformtype?.slipperDescriptionTh}
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.slipperSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== '' &&
                            surveys.slipperSize === undefined
                              ? 'require'
                              : ''
                          }`}
                          size="sm"
                          name="slipperSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t('uniform_survey.choose_uniform.select_size')}
                          </option>
                          <option value="9">9</option>
                          <option value="9.5">9.5</option>
                          <option value="10">10</option>
                          <option value="10.5">10.5</option>
                          <option value="11">11</option>
                          <option value="11.5">11.5</option>
                          <option value="Bigger than normal size">
                            {t('uniform_survey.choose_uniform.big_size')}
                          </option>
                          <option value="Decline">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {uniformtype?.slipperQty}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.braQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() => handleChartOpen('bras')}
                    >
                      <img
                        src="../images/uniform/bras.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t('uniform_survey.choose_uniform.size_chart')}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem('Language') === 'en'
                          ? uniformtype?.braDescriptionEn
                          : uniformtype?.braDescriptionTh}
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.braSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== '' &&
                            surveys.braSize === undefined
                              ? 'require'
                              : ''
                          }`}
                          size="sm"
                          name="braSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t('uniform_survey.choose_uniform.select_size')}
                          </option>
                          <option value="B 65/30">B 65/30</option>
                          <option value="B 70/32">B 70/32</option>
                          <option value="B 75/34">B 75/34</option>
                          <option value="B 80/36">B 80/36</option>
                          <option value="B 85/38">B 85/38</option>
                          <option value="B 90/40">B 90/40</option>
                          <option value="B 95/42">B 95/42</option>
                          <option value="Bigger than normal size">
                            {t('uniform_survey.choose_uniform.big_size')}
                          </option>
                          <option value="Decline">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {uniformtype?.braQty}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.tumblerQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4} md={2} lg={2} className="uniform-item m-0 p-0">
                      <img
                        src="../images/uniform/tumbler.png?a1"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem('Language') === 'en'
                          ? uniformtype?.tumblerDescriptionEn
                          : uniformtype?.tumblerDescriptionTh}
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.tumblerType}
                          className={`mt-2 mb-3 ${
                            validdateData !== '' &&
                            surveys.tumblerType == undefined
                              ? 'require'
                              : ''
                          }`}
                          size="sm"
                          name="tumblerType"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t('uniform_survey.choose_uniform.select_tumbler')}
                          </option>
                          <option value="Accept">
                            {t('uniform_survey.choose_uniform.receive')}
                          </option>
                          <option value="Decline">
                            {t('uniform_survey.choose_uniform.no_receive')}
                          </option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {uniformtype?.tumblerQty}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </Container>
          </div>
          <ValidateFormModal
            show={modalValidateShow}
            message={validdateData}
            onHide={() => setModalValidateShow(false)}
          />

          {pageLoder ? (
            <div className="pageLoder">
              <div className="loader">
                <div className="spinner"></div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
        {uniformtype && uniformtype?.shirtQty != null ? (
          <Modal.Footer>
            <div className="text-center w-100">
              <Button
                className="btn-no mx-2 btn-submit"
                onClick={() => handleOpen()}
              >
                {' '}
                Submit{' '}
              </Button>
              <Button
                className="btn-yes btn-cancel mx-2"
                onClick={closeModalClearData}
              >
                {' '}
                Cancel{' '}
              </Button>
            </div>
          </Modal.Footer>
        ) : (
          <></>
        )}
      </Modal>

      <ToastContainer />
    </>
  );
};
